import "./Footer.css";

export default function Footer() {
	return (
		<div className="footer">
			<p className="copyright">Copyright @ 2021 Keith Price</p>
		</div>
	);
}
